<template>
  <div>{{ value.toLocaleString($i18n.locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 }) }}</div>
</template>

<script>
export default {
  props: ['value'],
};
</script>
